module.exports = __webpack_public_path__ + "img/card-6.b5121b39.png";